import { render } from "./Calculation.vue?vue&type=template&id=daa66b02&scoped=true"
import script from "./Calculation.vue?vue&type=script&lang=js"
export * from "./Calculation.vue?vue&type=script&lang=js"

import "./Calculation.vue?vue&type=style&index=0&id=daa66b02&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-daa66b02"

export default script